import React from "react";
import { Card, Button, Table, Badge } from "react-bootstrap";
import { IconRefresh } from "@tabler/icons-react";
import { useSeasonHistory } from "./context/SeasonHistoryContext";

function SeasonHistorySection() {
  const { seasonHistory, refetch, Pagination } = useSeasonHistory();

  return (
    <Card className="p-3" style={{ marginTop: "32px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <h2 style={{ fontSize: "20px", fontWeight: "600" }}>Season History</h2>
        <Button
          variant="outline-info"
          onClick={refetch}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <IconRefresh size={16} />
          Refresh Data
        </Button>
      </div>
      <div style={{ padding: "0", overflowX: "auto" }}>
        <Table
          striped
          bordered
          hover
          style={{ marginBottom: "0", minWidth: "600px" }}
        >
          <thead>
            <tr>
              <th style={{ width: "64px" }}>🏆 Rank</th>
              <th>👤 Agent Name</th>
              <th>📅 Season</th>
              <th style={{ textAlign: "center" }}>🎖️ Tier</th>
              <th style={{ textAlign: "center" }}>⭐ Total Points</th>
            </tr>
          </thead>
          <tbody>
            {seasonHistory?.loading ? (
              <tr>
                <td
                  colSpan="5"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  <div className="d-flex justify-content-center align-items-center">
                    <div
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    Loading season history...
                  </div>
                </td>
              </tr>
            ) : seasonHistory?.error ? (
              <tr>
                <td
                  colSpan="5"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  <div className="alert alert-danger" role="alert">
                    <strong>Error loading season history:</strong>{" "}
                    {seasonHistory.error}
                  </div>
                </td>
              </tr>
            ) : seasonHistory.data && seasonHistory.data.length > 0 ? (
              seasonHistory.data.map((history, index) => (
                <tr key={history.id || index}>
                  <td style={{ fontWeight: "500" }}>{history.rank}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          backgroundColor: history.agent?.color || "#6b7280",
                          border: "1px solid #dee2e6",
                        }}
                        className="p-1 rounded-2"
                      >
                        {history.agent?.name || "Unknown Agent"}
                      </span>
                    </div>
                  </td>
                  <td>{history.season?.name || "Unknown Season"}</td>
                  <td style={{ textAlign: "center" }}>
                    <Badge
                      style={{
                        backgroundColor: "#6b7280", // Default color, or map tier to color
                        color: "#ffffff",
                      }}
                    >
                      {history.tier || "Unknown"}
                    </Badge>
                  </td>
                  <td style={{ textAlign: "center", fontWeight: "500" }}>
                    {history.total_points || 0}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="5"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No season history available
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        {Pagination && <div style={{ padding: "16px" }}>{Pagination}</div>}
      </div>
    </Card>
  );
}

export default SeasonHistorySection;
